import { AccountWithExtraInfo, Currency } from '@orbis-systems/orbis-api-middleware';

export const convertAccountsToBaseCurrency = (
    accounts: AccountWithExtraInfo[],
    fxRate: number,
    baseCurrency: string,
): AccountWithExtraInfo[] => {
    return accounts.map((account) => ({
        ...account,
        balance: (account.balance ?? 0) * fxRate,
        cashOnAccount: (account.cashOnAccount ?? 0) * fxRate,
        markToMarket: (account.markToMarket ?? 0) * fxRate,
        sodCashBalance: (account.sodCashBalance ?? 0) * fxRate,
        sodMarginBalance: (account.sodMarginBalance ?? 0) * fxRate,
        sodShortBalance: (account.sodShortBalance ?? 0) * fxRate,
        totalDividendAmount: (account.totalDividendAmount ?? 0) * fxRate,
        currency: baseCurrency || Currency.UsDollar,
    }));
};
